import apiClient from "./api";



async function updateFnbExtrasRevenues(id, data) {
    try {
      const response = await apiClient.post(
        `/create-outlet-season/${id}`,
        data
      );
      return response.data; // Return the actual data part of the response
    } catch (error) {
      // Handle the error response
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
}



async function getFnbExtrasRevenues(budgetId) {
    try {
      const response = await apiClient.get(
        `/get-outlet-seasons/${budgetId}`);
      return response.data; // Return the actual data part of the response
    } catch (error) {
      // Handle the error response
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
}

export { updateFnbExtrasRevenues, getFnbExtrasRevenues };
